import React from 'react';
import { colors } from './constants';

const DashboardHeader = () => (
  <div className="mb-6 p-5 rounded-xl" style={{ background: colors.gradient.green }}>
    <h1 className="text-2xl font-bold text-white">
      Tableau de bord administratif
    </h1>
    <p className="text-green-100">
      Statistiques et indicateurs clés de la plateforme
    </p>
  </div>
);

export default DashboardHeader;
